import { useNavigate } from "react-router-dom";

const DaysOfJavaScript = () => {
  const navigate = useNavigate();

  return (
    <div className="projectContainer">
      <button className="backButton" onClick={() => navigate("/projects")}>
        BACK
      </button>
      <h1>
        100 Days Of JavaScript{" "}
        <a
          target="_blank"
          href="https://github.com/stars/jleviharris/lists/100-day-of-javascript"
        >
          <i className="fa-brands fa-github gitHubProjLink"></i>
        </a>
      </h1>
      <div className="projectIcons">
        <div className="singleTech">
          <i className="fa-brands fa-html5 icons"></i>HTML
        </div>
        <div className="singleTech">
          <i className="fa-brands fa-css3-alt icons"></i>CSS
        </div>{" "}
        <div className="singleTech">
          <i className="fa-brands fa-square-js icons"></i>JavaScript
        </div>
        <div className="singleTech">
          <i className="fa-brands fa-react icons"></i>React.js
        </div>
        <div className="singleTech">
          <i className="fa-brands fa-node icons"></i>Node.js
        </div>
        <div className="singleTech">
          <i className="fa-brands fa-github icons"></i> Github
        </div>
        <div className="singleTech">
          <iconify-icon icon="simple-icons:netlify"></iconify-icon>
          Netlify
        </div>
      </div>
      <p>
        <a
          target="_blank"
          href="https://www.udemy.com/course/100-days-of-javascript/"
        >
          100 Days of JavaScript
        </a>{" "}
        is a Udemy Course I am currently taking designed to sharpen your
        JavaScript skills by building Amazing projects over 100 Days with HTML,
        CSS and JavaScript. As an extra challenge to myself I am also using
        React.js to create individual applications for each day that I am
        hosting on Netlify.
      </p>
      <div className="daysContainer">
        <h2>
          Day 1 -{" "}
          <a
            target="_blank"
            href="https://devjleviharriscounterapp.netlify.app/"
          >
            Counter App
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/counterApp.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 2 -{" "}
          <a
            target="_blank"
            href="https://devjonharrisrandomnumgen.netlify.app/"
          >
            Random Number Generator
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/randomNumberGen.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 3 -{" "}
          <a target="_blank" href="https://devjonharrisrndmhexgen.netlify.app/">
            Random Hex Color Generator
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/rndmhexgenday3.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 4 -{" "}
          <a target="_blank" href="https://devjonharrismodalpopup.netlify.app/">
            Modal/Popup
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/modalPopupDay4.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 5 -{" "}
          <a target="_blank" href="https://devjonharrispalindrome.netlify.app/">
            Palindrome Checker
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/palindromeDay5.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 6 -{" "}
          <a
            target="_blank"
            href="https://devjonharrisvowelcounter.netlify.app/"
          >
            Vowel Counter
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/vowelCounterDay6.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 7 -{" "}
          <a
            target="_blank"
            href="https://devjonharrisclicktocopy.netlify.app/"
          >
            Click To Copy
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/clicktocopy.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 8 -{" "}
          <a
            target="_blank"
            href="https://devjonharrisdrivedwnldlinkgen.netlify.app/"
          >
            Google Drive Download Link Generator
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/googleDriveDownloadLinkDay8.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 9 -{" "}
          <a
            target="_blank"
            href="https://devjonharrisinputcharcounter.netlify.app/"
          >
            Input Character Counter
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/inputCharCountDay9.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 10 -{" "}
          <a
            target="_blank"
            href="https://devjonharrisinternetconnectionstatus.netlify.app/"
          >
            Internet Connection Checker
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/internetConnectionStatusDay10.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 11 -{" "}
          <a
            target="_blank"
            href="https://devjonharriszombiesquiz.netlify.app/"
          >
            Quiz App
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/quizAppDay11.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 12 -{" "}
          <a
            target="_blank"
            href="https://devjonharrisapigeolocation.netlify.app/"
          >
            API geolocation
          </a>{" "}
          <a target="_blank" href="https://github.com/jleviharris/apiDay12.git">
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 13 -{" "}
          <a
            target="_blank"
            href="https://devjonharrishttprequest.netlify.app/"
          >
            HTTP request
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/httpRequestDay13.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 14 -{" "}
          <a
            target="_blank"
            href="https://devjonharris-random-quote-gen.netlify.app/"
          >
            Random Quote Generator
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/randomQuoteGenDay14.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 15 -{" "}
          <a
            target="_blank"
            href="https://devjonharris-weather-app.netlify.app/"
          >
            Weather App
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/weatherAppDay15.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>
        <h2>
          Day 16 -{" "}
          <a
            target="_blank"
            href="https://devjonharris-list-search.netlify.app/"
          >
            List Search
          </a>{" "}
          <a
            target="_blank"
            href="https://github.com/jleviharris/listSearchDay16.git"
          >
            <i className="fa-brands fa-github gitHubProjLink"></i>
          </a>
        </h2>

        <h2>Day 17- </h2>
        <h2>Day 18 - </h2>
        <h2>Day 19 - </h2>
        <h2>Day 20 - </h2>
        <h2>Day 21- </h2>
        <h2>Day 22 - </h2>
        <h2>Day 23 - </h2>
        <h2>Day 24 - </h2>
        <h2>Day 25 - </h2>
        <h2>Day 26 - </h2>
        <h2>Day 27 - </h2>
        <h2>Day 28 - </h2>
        <h2>Day 29 - </h2>
        <h2>Day 30 - </h2>
        <h2>Day 31 - </h2>
        <h2>Day 32 - </h2>
        <h2>Day 33 - </h2>
        <h2>Day 34 - </h2>
        <h2>Day 35 - </h2>
        <h2>Day 36 - </h2>
        <h2>Day 37 - </h2>
        <h2>Day 38 - </h2>
        <h2>Day 39 - </h2>
        <h2>Day 40 - </h2>
        <h2>Day 41 - </h2>
        <h2>Day 42 - </h2>
        <h2>Day 43 - </h2>
        <h2>Day 44 - </h2>
        <h2>Day 45 - </h2>
        <h2>Day 46 - </h2>
        <h2>Day 47 - </h2>
        <h2>Day 48 - </h2>
        <h2>Day 49 - </h2>
        <h2>Day 50 - </h2>
        <h2>Day 51 - </h2>
        <h2>Day 52 - </h2>
        <h2>Day 53 - </h2>
        <h2>Day 54 - </h2>
        <h2>Day 55 - </h2>
        <h2>Day 56 - </h2>
        <h2>Day 57 - </h2>
        <h2>Day 58 - </h2>
        <h2>Day 59 - </h2>
        <h2>Day 60 - </h2>
        <h2>Day 61 - </h2>
        <h2>Day 62 - </h2>
        <h2>Day 63 - </h2>
        <h2>Day 64 - </h2>
        <h2>Day 65 - </h2>
        <h2>Day 66 - </h2>
        <h2>Day 67 - </h2>
        <h2>Day 68 - </h2>
        <h2>Day 69 - </h2>
        <h2>Day 70 - </h2>
        <h2>Day 71 - </h2>
        <h2>Day 72 - </h2>
        <h2>Day 73 - </h2>
        <h2>Day 74 - </h2>
        <h2>Day 75 - </h2>
        <h2>Day 76 - </h2>
        <h2>Day 77 - </h2>
        <h2>Day 78 - </h2>
        <h2>Day 79 - </h2>
        <h2>Day 80 - </h2>
        <h2>Day 81 - </h2>
        <h2>Day 82 - </h2>
        <h2>Day 83 - </h2>
        <h2>Day 84 - </h2>
        <h2>Day 85 - </h2>
        <h2>Day 86 - </h2>
        <h2>Day 87 - </h2>
        <h2>Day 88 - </h2>
        <h2>Day 89 - </h2>
        <h2>Day 90 - </h2>
        <h2>Day 91 - </h2>
        <h2>Day 92 - </h2>
        <h2>Day 93 - </h2>
        <h2>Day 94 - </h2>
        <h2>Day 95 - </h2>
        <h2>Day 96 - </h2>
        <h2>Day 97 - </h2>
        <h2>Day 98 - </h2>
        <h2>Day 99 - </h2>
        <h2>Day 100 - </h2>
      </div>
    </div>
  );
};

export default DaysOfJavaScript;
